"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _core = _interopRequireDefault(require("../../utils/core"));

(function (webf) {
  webf.lang.en = webf.lang.en || {};
  webf.lang.en.ajaxupload = {
    invExtension: function invExtension(filename, allowedExtensions) {
      return "The file " + filename + " is not an extension validation.\nValid extensions : " + allowedExtensions;
    },
    invSize: function invSize(filename, filesize, sizeLimit) {
      return "The file " + filename + " of " + filesize + " exceeds the size limit " + sizeLimit;
    },
    emptyFile: function emptyFile(filename) {
      return "The file " + filename + " is empty";
    }
  };
})(_core["default"]);